__turbopack_context__.v({
  "language": "vo1EPa_language",
  "language-switcher": "vo1EPa_language-switcher",
});
